import { useEffect, useMemo } from 'react';

import { useOnboardingUserInfo } from 'src/hooks/use-onboarding-user-info';
import { useUserAssets } from 'src/hooks/use-user-assets.hook';
import { getAmpConfigFlags } from 'src/services/amp-config.service';

export const useNavigationApiDataPassing = () => {
  const { data: onboardingUserInfo, isLoading: isOnboardingUserInfoLoading } =
    useOnboardingUserInfo();
  const { isLoadingWithoutError: isUserAssetsLoading, data: userAssets } =
    useUserAssets();

  const apiDataConfig = useMemo(
    () => ({
      apiData: {
        retail: {
          userAssets: {
            data: userAssets,
            isLoading: isUserAssetsLoading,
          },
        },
        onboarding: {
          userInfo: {
            data: onboardingUserInfo,
            isLoading: isOnboardingUserInfoLoading,
          },
        },
      },
    }),
    [
      userAssets,
      isUserAssetsLoading,
      onboardingUserInfo,
      isOnboardingUserInfoLoading,
    ],
  );

  useEffect(() => {
    const { isNewNavigationEnabled } = getAmpConfigFlags();

    if (isNewNavigationEnabled && window.AmpNavigationV2Module) {
      const { updateConfig } = window.AmpNavigationV2Module;
      updateConfig(apiDataConfig);
    }
  }, [apiDataConfig]);
};
